import React, {useEffect, useState} from "react"
import { Div, Text, Container, Col, Row, Icon, Input} from "atomize";
import styled from "styled-components";
import Header from "../Components/Molecules/Header";
import Routes from "../Routes";
import {apiGet} from "../Api";
import { selectStyles } from "../Components/Atoms/Select";
import GrayBg from "../Components/Atoms/GrayBg";
import Select from "react-select";
import makeAnimated from 'react-select/animated';
import ActivityCard, {LoadingActivityCard} from "../Components/Molecules/ActivityCard";
import Heading from "../Components/Atoms/Heading";
import theme from "./../Theme/Theme";
import Toggle from "../Components/Atoms/Toggle";
import TimeLineGraph from "../Components/Moldules/TimeLineGraph";
import {ReactComponent as OnionIcon} from "./../Assets/Icons/onion_sm.svg";
import {ReactComponent as CaterpillarIcon} from "./../Assets/Icons/caterpillar_sm.svg";
import {ReactComponent as TypesIcon } from "./../Assets/Icons/e4h/types_sm.svg";
import ExperienceModal from "../Components/Molecules/ExperienceModal";
import PhaseModal from "../Components/Molecules/PhaseModal";
import {setActivityView, setActivityQuery} from "../redux/actions";
import { connect } from "react-redux";
import {bindActionCreators} from "redux";
import SEO from "../Components/Atoms/SEO";
import ReactGA from "react-ga";
// import {ReactComponent as ActivityIcon} from "./../Assets/Icons/activities_sm.svg";

const animatedComponents = makeAnimated();

const Label = styled.label`
  font-family: Inter;
  font-weight: 600;
  font-size: 16px;
  color: ${theme.colors.dark};
  letter-spacing: 0;
  line-height: 30px;
`;

const SearchInput = styled(Input)`
    &:focus {
      border: 2px solid ${theme.colors.primary};
    } 
`;

const ReverseCol = styled(Col)`
    align-items: flex-end;
    display: flex;
    flex-direction: column;
`;

const FiltersRow = styled(Row)`
  .experience-placeholder, .phase-placeholder {
    svg {
      margin-bottom: -4px;
      margin-right: 5px;
    }
  }
  .type-placeholder {
    svg {
      margin-bottom: -5px;
      margin-right: 5px;
      opacity: .75;
    }
  }
  
  .select-org {
    width: 100%;
  }
  .info-btn {
    margin-left: 5px;
  }
`


const Arr = [1,2,3,4,5,6,7,8,9,10];

const check = (arr, name) => {
  let c = false;
  if (arr.length === 0) {
    c = true;
  } else {
    c = arr.some( el => el.name.includes(name)) > 0;
  }
  return c
};

function Activities(props) {
  ReactGA.pageview(window.location.pathname + window.location.search);

  const [typeOptions, setTypeOptions] = useState(null);
  const [experienceOptions, setExperienceOptions] = useState(null);
  const [phaseOptions, setPhaseOptions] = useState(null);
  const [data, setData] = useState(null);
  const [heroImgUrl, setHeroImgUrl] = useState(null);
  const [activities, setActivities] = useState(null);
  const [typeFilters, setTypeFilters] = useState(null);
  const [experienceFilters, setExperienceFilters] = useState(null);
  const [phaseFilters, setPhaseFilters] = useState(null);
  const [activitiesPhase1, setActivitiesPhase1] = useState(null);
  const [activitiesPhase2, setActivitiesPhase2] = useState(null);
  const [activitiesPhase3, setActivitiesPhase3] = useState(null);
  const [selectLoading, setSelectLoading] = useState(true);
  const [searchValue, setSearchValue] = useState('');
  const [experienceModalOpen, setExperienceModalOpen] = useState(false);
  const [phaseModalOpen, setPhaseModalOpen] = useState(false);
  const [didMount, setDidMount] = useState(false);
  const view = props.activityView;

  const page = Routes.filter( route => {
    return route.path === props.location.pathname
  });

  let pageTitle = '';

  if (page.length > 0) {
    pageTitle = page[0].name;
  }

  const mapActivities = (activities) => {
    let activitiesPhase1 = [];
    let activitiesPhase2 = [];
    let activitiesPhase3 = [];
    activities.forEach( activity => {
      if (activity.field_course_phase.name && activity.field_course_phase.name === "Who's our partner?") {
        activitiesPhase1.push(activity)
      }
      if (activity.field_course_phase.name && activity.field_course_phase.name === "What's our project?") {
        activitiesPhase2.push(activity)
      }
      if (activity.field_course_phase.name && activity.field_course_phase.name === "What's our product?") {
        activitiesPhase3.push(activity)
      }
    });
    setActivitiesPhase1(activitiesPhase1);
    setActivitiesPhase2(activitiesPhase2);
    setActivitiesPhase3(activitiesPhase3);
  };

  useEffect(() => {
    const loadFromPath = (activitiesLoad, typeOptionLoad, experienceOptionLoad, phaseOptionLoad) => {
      const urlParams = new URLSearchParams(window.location.search);

      const parseParams = (type,options) => {
        let el = [];
        let elFill = false;
        if (urlParams.get(type)) {
          el = urlParams.get(type);
          el = options.filter( obj => {
            return el.includes(obj.name);
          });
          elFill = el.length === options.length;
        }
        return {
          el: el,
          elFill: elFill
        }
      };

      const typeParams = parseParams('type', typeOptionLoad);
      let t = typeParams.el;
      let tFill = typeParams.elFill;

      const experienceParams = parseParams('experience', experienceOptionLoad);
      let e = experienceParams.el;
      let eFill = experienceParams.elFill;

      const phaseParams = parseParams('phase', phaseOptionLoad);
      let p = phaseParams.el;
      let pFill = phaseParams.elFill;

      if (!didMount) {

        const handleMount = (el, elFill, setFilters) => {
          if (!elFill) {
            setFilters([]);
          } else {
            setFilters(el);
          }
        };

        handleMount(t, tFill, setTypeFilters);
        handleMount(e, eFill, setExperienceFilters);
        handleMount(p, pFill, setPhaseFilters);
        setSelectLoading(false);
      }

      activitiesLoad = activitiesLoad.filter(activity => {
        const tCheck = check(t, activity.field_activity_type.name);
        const eCheck = check(e, activity.field_experience_layer.name);
        const pCheck = check(p, activity.field_course_phase.name);
        return ( tCheck && eCheck && pCheck )
      });

      setTypeFilters(t);
      setExperienceFilters(e);
      setPhaseFilters(p);

      mapActivities(activitiesLoad);
    };

    async function fetchData() {
      const result = await apiGet(`/node/page?filter[title]=${pageTitle}&include=field_banner_image`);
      setData(result.data);
      setHeroImgUrl(result.data.included[0].attributes.uri.url);

      const formatOptions = (r) => {
        let options = [];
        r.forEach( el => {
          el.value = el.id;
          el.label = el.name;
          el.key= el.id;
          options.push(el);
        });
        return r;
      } ;

      let typeResult = await apiGet(`/taxonomy_term/activity_types?jsonapi_include=1`);
      const typeOptions = formatOptions(typeResult.data.data);
      setTypeOptions(typeOptions);

      let experienceResult = await apiGet(`/taxonomy_term/experience_layers?jsonapi_include=1`);
      let experienceOptions = formatOptions(experienceResult.data.data);
      [experienceOptions[0], experienceOptions[1], experienceOptions[2]] = [experienceOptions[1],experienceOptions[2],experienceOptions[0]];
      setExperienceOptions(experienceOptions);

      let phasesResult = await apiGet(`/taxonomy_term/course_phases?jsonapi_include=1`);
      const phaseOptions = formatOptions(phasesResult.data.data);
      setPhaseOptions(phaseOptions);

      let activitiesQueResult = await apiGet(`/entity_subqueue/activity_queue?include=items&jsonapi_include=1`);
      activitiesQueResult = activitiesQueResult.data.data[0].items;
      activitiesQueResult.forEach( (activity,i) => {
        activitiesQueResult[i].field_activity_type = typeOptions.find( t => { return t.id === activity.field_activity_type.id });
        activitiesQueResult[i].field_experience_layer = experienceOptions.find( e => { return e.id === activity.field_experience_layer.id });
        activitiesQueResult[i].field_course_phase = phaseOptions.find( p => { return p.id === activity.field_course_phase.id });
      });

      setActivities(activitiesQueResult);

      if (props.history.location.search !== "") {
        loadFromPath(activitiesQueResult, typeOptions, experienceOptions, phaseOptions);
        props.setActivityQuery(props.history.location.search);
      } else if (props.activityQuery !== "") {
        props.history.push(props.activityQuery);
      } else {
        loadFromPath(activitiesQueResult, typeOptions, experienceOptions, phaseOptions);
      }
    }

    if (!didMount) {
      fetchData()
        .then( () => {
          setDidMount(true);
        });
    }
    else if (props.history.location.search !== "") {
      loadFromPath(activities, typeOptions, experienceOptions, phaseOptions);
    }
  }, [props.history.location.search]);

  const updateHisorty = (t, e, p) => {

    const formatParam = (el) => {
      if (el === null || el.length === 0 ) {
        el = "all"
      } else {
        let elNames = [];
        el.forEach( obj => {
          elNames.push(obj.name);
        });
        el = encodeURIComponent(elNames.join());
      }
      return el;
    };

    t = formatParam(t);
    e = formatParam(e);
    p = formatParam(p);

    setSearchValue('');
    props.history.push(`?type=${t}&experience=${e}&phase=${p}`);
    props.setActivityQuery(`?type=${t}&experience=${e}&phase=${p}`);
    ReactGA.pageview(window.location.pathname + window.location.search);
  };

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    let term = e.target.value.toLowerCase();
    let searchedActivites = activities.filter( (item) => {
      return item.title.toLowerCase().search(
        term ) !== -1;
    });

    let filteredSearchedActivies = searchedActivites.filter(activity => {
      const tCheck = check(typeFilters, activity.field_activity_type.name);
      const eCheck = check(experienceFilters, activity.field_experience_layer.name);
      const pCheck = check(phaseFilters, activity.field_course_phase.name);
      return ( tCheck && eCheck && pCheck )
    });
    mapActivities(filteredSearchedActivies);
  };

  return (
    <Div>
      <SEO
        title={ "Activities | Engineering for Humanity | Olin College of Engineering"}
        description={data && data.field_description ? data.field_description : null}
      />
      <Header
        pageTitle={pageTitle}
        heroImgUrl={heroImgUrl}
      />
      <GrayBg>
        <Container>
          <Row
            p={{ t: '2rem', b: '1rem'}}
          >
            <Col
              size={{ xs: '12', sm: '8', md: '8', lg: '8' }}
            >
              <Label
                htmlFor={'search'}
              >Search</Label>
              <SearchInput
                name={'search'}
                id={'search'}
                value={searchValue}
                onChange={ (e) => handleSearch(e)}
                hoverBorderColor={theme.colors.primary}
                focusBorderColor={theme.colors.primary}
                suffix={
                  <Icon
                    name="Search"
                    size="20px"
                    cursor="pointer"
                    pos="absolute"
                    top="50%"
                    right="1rem"
                    transform="translateY(-50%)"
                    color={'rgb(201, 206, 214)'}
                  />
                }
              />
            </Col>
            <ReverseCol
              size={{ xs: '12', sm: '4', md: '4', lg: '4' }}
            >
              <Label>View</Label>
              <Toggle
                type={'graph'}
                action={ (e) => props.setActivityView(e)}
                value={view}
              />
            </ReverseCol>
          </Row>
          <FiltersRow
            p={{ b: '2rem' }}
          >
            <Col size={'12'} >
              <Label>Filter</Label>
            </Col>
            <Col
              size={{ xs: '12', sm: '12', md: '4', lg: '4' }}
              style={{ marginBottom: '.5rem'}}
            >
              <Select
                className="select-org"
                classNamePrefix="select"
                onChange={(t) => updateHisorty(t, experienceFilters, phaseFilters)}
                placeholder={<span className={'type-placeholder'}><TypesIcon/>Filter by activity types</span>}
                isDisabled={false}
                isLoading={selectLoading}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                isMulti={true}
                name="orgs"
                options={typeOptions}
                components={animatedComponents}
                styles={selectStyles}
                value={typeFilters}
              />
            </Col>
            <Col
              size={{ xs: '12', sm: '12', md: '4', lg: '4' }}
              d={'flex'}
              style={{ marginBottom: '.5rem'}}
            >
              <Select
                className="select-org"
                classNamePrefix="select"
                placeholder={<span className={'experience-placeholder'}><OnionIcon/>Filter by experience layers</span>}
                onChange={(e) => updateHisorty(typeFilters, e, phaseFilters)}
                isDisabled={false}
                isLoading={selectLoading}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                isMulti={true}
                name="orgs"
                options={experienceOptions}
                components={animatedComponents}
                styles={selectStyles}
                value={experienceFilters}
              />
              <a
                href={"#"}
                className={'info-btn'}
                aria-label={'more information about experience options'}
                onClick={e => {
                  e.preventDefault();
                  setExperienceModalOpen(true);
                }}
              >
                <Icon
                  name="Info"
                  size="20px"
                  color={theme.colors.gray}
                />
              </a>
              <ExperienceModal
                open={experienceModalOpen}
                close={() => setExperienceModalOpen(false)}
              />
            </Col>
            <Col
              size={{ xs: '12', sm: '12', md: '4', lg: '4' }}
              d={'flex'}
            >
              <Select
                className="select-org"
                classNamePrefix="select"
                placeholder={<span className={'phase-placeholder'}><CaterpillarIcon/>Filter by course phase</span>}
                onChange={(p) => updateHisorty(typeFilters, experienceFilters, p)}
                isDisabled={false}
                isLoading={selectLoading}
                isClearable={true}
                isRtl={false}
                isSearchable={true}
                isMulti={true}
                name="orgs"
                options={phaseOptions}
                components={animatedComponents}
                styles={selectStyles}
                value={phaseFilters}
              />
              <a
                href={"#"}
                className={'info-btn'}
                aria-label={'more information about phase options'}
                onClick={e => {
                  e.preventDefault();
                  setPhaseModalOpen(true);
                }}
              >
                <Icon
                  name="Info"
                  size="20px"
                  color={theme.colors.gray}
                />
              </a>
              <PhaseModal
                open={phaseModalOpen}
                close={() => setPhaseModalOpen(false)}
              />
            </Col>
          </FiltersRow>
        </Container>
      </GrayBg>
      <Container>
        { view === 0 &&
          <>
            {
              !activitiesPhase1 && !activitiesPhase2 && !activitiesPhase3 &&
                <>
                  <Heading
                    size={'small'}
                    loading={true}
                  />
                  <Row>
                    {Arr.map(a => {
                      return (
                        <Col
                          size={{xs: '12', sm: '12', md: '6', lg: '6'}}
                          key={a}
                        >
                          <LoadingActivityCard/>
                        </Col>
                      )
                    })
                    }
                  </Row>
                </>
            }
            { activitiesPhase1 && activitiesPhase1.length > 0 &&
              <>
                <Heading
                  title={"Who's our Partner?"}
                  size={'small'}
                  count={ activitiesPhase1.length + 1 }
                  phase={true}
                />
                <Row
                // p={ {y: '2rem'} }
                >
                  {
                    activitiesPhase1.map( activity => {
                      return (
                        <Col
                          size={{ xs: '12', sm: '12', md: '6', lg: '6' }}
                          key={activity.id}
                        >
                          <ActivityCard
                            activity={activity}
                          />
                        </Col>
                      )
                    })
                  }
                </Row>
              </>
            }

            { activitiesPhase2 && activitiesPhase2.length > 0 &&
            <>
              <Heading
                title={"What's our project?"}
                size={'small'}
                count={ activitiesPhase2.length + 1 }
                phase={true}
              />
              <Row
                // p={ {y: '2rem'} }
              >
                {
                  activitiesPhase2.map( activity => {
                    return (
                      <Col
                        size={{ xs: '12', sm: '12', md: '6', lg: '6' }}
                        key={activity.id}
                      >
                        <ActivityCard
                          activity={activity}
                        />
                      </Col>
                    )
                  })
                }
              </Row>
            </>
            }

            { activitiesPhase3 && activitiesPhase3.length > 0 &&
            <>
              <Heading
                title={"What's our product?"}
                size={'small'}
                count={ activitiesPhase3.length + 1 }
                phase={true}
              />
              <Row
                // p={ {y: '2rem'} }
              >
                {
                  activitiesPhase3.map( activity => {
                    return (
                      <Col
                        size={{ xs: '12', sm: '12', md: '6', lg: '6' }}
                        key={activity.id}
                      >
                        <ActivityCard
                          activity={activity}
                        />
                      </Col>
                    )
                  })
                }
              </Row>
            </>
            }
          </>
        }
        {
          view === 1 &&
          <>
            <TimeLineGraph
              activitiesPhase1={activitiesPhase1 ? activitiesPhase1 : null}
              activitiesPhase2={activitiesPhase2 ? activitiesPhase2 : null}
              activitiesPhase3={activitiesPhase3 ? activitiesPhase3 : null}
            />
          </>
        }
      </Container>
    </Div>
  )
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      setActivityView: setActivityView,
      setActivityQuery: setActivityQuery
    },
    dispatch
  );
};

const mapStateToProps = state => {
  if (state === undefined) return {};
  return {
    activityView: state.collectorActivities.activityView,
    activityQuery: state.collectorActivities.activityQuery
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Activities);
